<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <div class="main-content flex-fill p-3">
        <div class="main-heading mb-3">
            <h1>Business Case Status Dashboard</h1>
        </div>

        <!-- Summary Counts -->
        <!-- Summary Counts Styled -->
        <div class="summary-box mb-4 p-3 shadow-sm bg-light rounded d-flex justify-content-around text-center">
            <div>
                <div class="summary-title">Total Records</div>
                <div class="summary-value">{{ summary.total_records }}</div>
            </div>
            <div>
                <div class="summary-title text-primary">Locked</div>
                <div class="summary-value">{{ summary.locked_count }}</div>
            </div>
            <div>
                <div class="summary-title text-success">Unlocked</div>
                <div class="summary-value">{{ summary.unlocked_count }}</div>
            </div>
            <div>
                <div class="summary-title text-danger">Not in Business Case</div>
                <div class="summary-value">{{ summary.not_in_businesscase_count }}</div>
            </div>
        </div>

        <!-- Filters -->
        <div class="d-flex justify-content-between align-items-center mb-3">
            <!-- Dropdown filter -->
            <div>
                <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus"
                    placeholder="Select Business Case Status" (onChange)="onStatusFilterChange()">
                </p-dropdown>
            </div>

            <!-- Search box -->
            <input type="text" pInputText placeholder="Search by Brand or NDA" [(ngModel)]="searchText"
                (input)="onSearchInputChange($event.target.value)">

        </div>

        <!-- Table -->
        <p-table [value]="filteredData" [paginator]="true" [rows]="10" [responsiveLayout]="'scroll'" [loading]="loading"
            [rowsPerPageOptions]="[5, 10, 20]">

            <ng-template pTemplate="header">
                <tr>
                    <th>Brand Name</th>
                    <th>NDA</th>
                    <th>Last Updated</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{ row.brand_name }}</td>
                    <td>{{ row.nda }}</td>
                    <td>{{ row.last_updated_time || 'N/A' }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>